import type { Locale } from "@/content/site";

const EXTERNAL_PROTOCOL = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i;

export const localeFromPath = (pathname: string): Locale =>
  pathname === "/fr" || pathname.startsWith("/fr/") ? "fr" : "en";

export const stripLocalePrefix = (pathname: string) => {
  if (pathname === "/fr") return "/";
  if (pathname.startsWith("/fr/")) return pathname.slice(3) || "/";
  return pathname || "/";
};

export const localizePath = (value: string, locale: Locale) => {
  if (!value || value.startsWith("#") || EXTERNAL_PROTOCOL.test(value)) return value;

  const match = value.match(/^([^?#]*)([?#].*)?$/);
  const pathname = match?.[1] || "/";
  const suffix = match?.[2] || "";
  const unprefixed = stripLocalePrefix(pathname);

  if (locale === "fr") {
    return `${unprefixed === "/" ? "/fr" : `/fr${unprefixed}`}${suffix}`;
  }

  return `${unprefixed}${suffix}`;
};

export const pairedLocalePath = (
  pathname: string,
  targetLocale: Locale,
  search = "",
  hash = "",
) => `${localizePath(stripLocalePrefix(pathname), targetLocale)}${search}${hash}`;

export const absoluteLocalizedUrl = (siteUrl: string, pathname: string, locale: Locale) => {
  const localized = localizePath(pathname, locale);
  return `${siteUrl}${localized === "/" ? "" : localized}`;
};
